import { Component } from '@angular/core';

@Component({
  selector: 'ngx-footer',
  styleUrls: ['./footer.component.scss'],
  template: `
    <span class="created-by">
      Copyright© WOLFCOM® 2020
    </span>
    <div class="socials">
      <a href="https://www.facebook.com/WolfcomUSA/" target="_blank" class="ion ion-social-facebook"></a>
      <a href="https://twitter.com/wolfcom_usa/" target="_blank" class="ion ion-social-twitter"></a>
      <a href="https://www.linkedin.com/company/wolfcom%C2%AE" target="_blank" class="ion ion-social-linkedin"></a>
    </div>
  `,
})
export class FooterComponent {
}
